let n = 1;

export default function newid() {
  return `id-${n++}`;
}
